import {ident} from './ident';

const undef = ident();

export {undef};
